"use client";

import React from "react";

const DentalServicesAndTech: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        A Look into Our Dental Services & Technology
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        At Smile4Me, we are proud to offer a comprehensive range of dental services designed to meet the unique needs of our patients. In addition to custom night guards, we provide various cosmetic treatments, such as teeth whitening, veneers, and orthodontic solutions like Invisalign®. Our commitment to staying at the forefront of dental technology ensures that our patients receive the most advanced and effective care possible.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        Some of the cutting-edge tools and techniques we employ in our practice include:
      </p>
      <ul className="list-disc list-inside space-y-2 text-gray-700 text-base sm:text-lg">
        <li>Digital radiography for reduced radiation exposure and enhanced image quality</li>
        <li>Intraoral cameras to provide a clear view of your teeth and gums during exams</li>
        <li>CAD/CAM technology for same-day dental restorations</li>
        <li>Laser dentistry for precise, minimally invasive treatments</li>
      </ul>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
        By combining our expertise with the latest advancements in dental care, we strive to deliver exceptional results that exceed your expectations.
      </p>
    </div>
  );
};

export default DentalServicesAndTech;